import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Evento } from '../eventos/evento.model';
import { RegistrarseComponent } from '../registrarse/registrarse.component';
import { EventoDataService } from '../service/data/evento-data.service';
import { TerminosYCondicionesComponent } from '../terminos-ycondiciones/terminos-ycondiciones.component';
import { TratamientoDatosComponent } from '../tratamiento-datos/tratamiento-datos.component';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {

  constructor(private dialog: MatDialog, private service: EventoDataService) { }
  eventos: Evento[] = [];
  ngOnInit(): void {
    this.service.getAllEventosVisibles().subscribe(
      response => {
        this.handleSuccesfullGet(response);

      }
    )
  }

  openDialog(): void {
    const dialogRef = this.dialog.open(RegistrarseComponent, {
      width: '600px',



    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');

    });
  }

  terminosYCondiciones() {
    const dialogRef = this.dialog.open(TerminosYCondicionesComponent, {
      width: '600px',
      height: '750px'

    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');

    });
  }

  tratamientoDatos() {
    const dialogRef = this.dialog.open(TratamientoDatosComponent, {
      width: '600px',
      height: '750px'

    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');

    });
  }


  handleSuccesfullGet(response) {
    this.eventos = response;


  }
}
